/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


$('body').on('click','.addToCart_btn',function(){
    let current = $(this);
    $(this).children('span').addClass('hidden');
    $(this).children('.loading-svg').removeClass('hidden');
    let variantId = $(this).attr('data-id');
    console.log(variantId);
    let itemObj = {
      id : variantId,
      quantity:1
    }
    let itemArray = [];
    itemArray.push(itemObj);
    let item = {
      items:itemArray
    };
    addTocart(item,current);
})
function addTocart(item,current){
  jQuery.post('/cart/add.js', item,function(data,status){
      if(status == 'success'){
       location.reload();
      }else{
        alert("something went wrong")
      }
    });
}